import {
    adminPaths,
    featurePaths,
    experimentalPaths,
    dashboardGroupLabelsByKey,
    normalizeModulePath,
    resolveDashboardGroupByPath,
} from './modulePathCatalog';

const ADMIN_PATHS = new Set(
    adminPaths.map(normalizeModulePath),
);

const FEATURE_PATHS = new Set(
    featurePaths.map(normalizeModulePath),
);

const EXPERIMENTAL_PATHS = new Set(
    experimentalPaths.map(normalizeModulePath),
);

const GROUP_LABELS = {
    admin: 'Admin',
    sbu: 'SBU',
    mbu: 'MBU',
    'location-analytics': 'Location Analytics',
    'markets-dashboard': 'Markets Dashboard',
    dac: 'DAC',
    'retail-dashboard': 'Retail Dashboard',
    'market-basket-analysis': 'Market Basket',
    feature: 'Feature Modules',
    others: 'Others',
    ungrouped: 'Ungrouped',
};

const MAJOR_GROUP_META = {
    admin: { label: 'Admin', color: '#6A1B9A', bgColor: '#F3E5F5', borderColor: '#CE93D8' },
    dashboard: { label: 'Dashboard', color: '#1565C0', bgColor: '#E3F2FD', borderColor: '#90CAF9' },
    feature: { label: 'Feature', color: '#00695C', bgColor: '#E0F2F1', borderColor: '#80CBC4' },
    others: { label: 'Others', color: '#5F6368', bgColor: '#F1F3F4', borderColor: '#DADCE0' },
    ungrouped: { label: 'Ungrouped', color: '#8D6E63', bgColor: '#EFEBE9', borderColor: '#BCAAA4' },
};

function normalizeModuleName(moduleName = '') {
    return normalizeModulePath(moduleName);
}

export function inferModuleGroup(moduleName) {
    const normalized = normalizeModuleName(moduleName);
    if (!normalized) return 'ungrouped';

    if (ADMIN_PATHS.has(normalized)) return 'admin';
    if (FEATURE_PATHS.has(normalized)) return 'feature';

    const dashboardGroup = resolveDashboardGroupByPath(normalized);
    if (dashboardGroup) return dashboardGroup.key;

    const [firstSegment = '', secondSegment = ''] = normalized.split('/');

    if (EXPERIMENTAL_PATHS.has(normalized)) return 'others';
    if (firstSegment === 'admin' || firstSegment.includes('management')) return 'admin';
    if (firstSegment === 'sbu') return 'sbu';
    if (firstSegment === 'mbu') return 'mbu';
    if (firstSegment === 'location-analytics') return 'location-analytics';
    if (firstSegment === 'markets-dashboard') return 'markets-dashboard';
    if (firstSegment === 'dac') return 'dac';
    if (firstSegment === 'retail-dashboard') return 'retail-dashboard';
    if (firstSegment === 'market-basket-analysis') return 'market-basket-analysis';

    if (firstSegment === 'others') {
        return secondSegment ? `others/${secondSegment}` : 'others';
    }


    return firstSegment || 'ungrouped';
}

export function getModuleGroupLabel(groupKey) {
    if (GROUP_LABELS[groupKey]) return GROUP_LABELS[groupKey];
    if (dashboardGroupLabelsByKey[groupKey]) return dashboardGroupLabelsByKey[groupKey];

    if (groupKey?.startsWith('others/')) {
        const suffix = groupKey.split('/')[1];
        return `Others / ${suffix}`;
    }

    return groupKey
        .split(/[-_]/g)
        .filter(Boolean)
        .map(token => token.charAt(0).toUpperCase() + token.slice(1))
        .join(' ');
}

export function getMajorGroupKey(groupKey = '') {
    if (groupKey === 'admin') return 'admin';
    if (groupKey === 'feature') return 'feature';
    if (groupKey === 'others' || groupKey?.startsWith('others/')) return 'others';
    if (groupKey === 'ungrouped') return 'ungrouped';

    if (groupKey?.startsWith('dashboard:')) return 'dashboard';
    if (['sbu', 'mbu', 'location-analytics', 'markets-dashboard', 'dac', 'retail-dashboard', 'market-basket-analysis'].includes(groupKey)) {
        return 'dashboard';
    }

    return 'others';
}

export function getMajorGroupMeta(groupKey = '') {
    const majorGroupKey = getMajorGroupKey(groupKey);
    return MAJOR_GROUP_META[majorGroupKey] || MAJOR_GROUP_META.others;
}


